import React from 'react';

import Field from './Field';
import FieldCheckBox from './FieldCheckBox';
import { getDefinedValue } from '../../util/tools';

class FieldCheckBoxGroup extends Field {
	
	constructor(props) {
		super(props);
	}

	handleInstanceChange = async (event) => {
	}
	
	render() {
		if( this.field == null ) {
			return this.createDivUnknownField();
		}
		let virtualGroupId = this.field.model.virtualGroupId;
		if( ! virtualGroupId ) {
			return (
				<div style={{margin: '10px', padding: '10px', border: '1px solid blue', backgroundColor: 'lightYellow'}}>
					<div>virtualGroupId is not defined</div>
				</div>
			)
		}
		let instanceModel = this.props.instance.model;
		let listField = [];
		for(let f of instanceModel.subfields) {
			if( f.virtualGroupName == virtualGroupId ) {
				listField.push( f );
			}
		}
		
		let colCount = getDefinedValue(this.props.colCount, 100);
		let rows = [];
		let newRow = [];
		for(let f of listField) {
			if( newRow.length == 0 )
				rows.push( newRow );
			newRow.push(f);
			if( newRow.length == colCount )
				newRow = [];
		}


		let checkBoxesHtml = rows.map( (row, index) => {
			let rowHtml = row.map( (fieldModel, index ) => {
				return (
					<td key={index}>
						<FieldCheckBox instance={this.props.instance} path={'/'+fieldModel.fieldId} plain={this.props.plain}
							readOnly={this.props.readOnly}
						/>
					</td>
				);
			});
			
			return <tr key={'row'+ index}>{rowHtml}</tr>
		} );
		
		return (
			<div style={{border: '1px solid blue', padding: '10px'}}>
				{this.createLabel()}
				<div style={{padding:'10px 0 0 10px'}}>
					<table>	
					<tr>	
					{checkBoxesHtml}
					</tr>
					</table>
				</div>
			</div>
		) 
	}
}

export default FieldCheckBoxGroup;